enum PerfilAgendamentoEnum {
  BackOffice = 'backOffice',
  Medico = 'medico',
  SecretariaMedico = 'secretariaMedico',
  SecretariaAgendamento = 'secretariaAgendamento',
  SecretariaAmbulatorio = 'secretariaAmbulatorio',
}

export default PerfilAgendamentoEnum
